import { useCommonApiManager } from './common-api-manager-module';

export const useCommonApi = () => {
  const manager = useCommonApiManager();

  return {
    manager,
  };
};
